import { useState } from "react";

export const useSettledWhileLoading = <T>(value: T, isLoading: boolean): T => {
  const [settledValue, setSettledValue] = useState(value);

  if (!isLoading && settledValue !== value) {
    setSettledValue(value);
  }

  return settledValue;
};
